/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {FieldTable} from '../model/fieldTable';
import {Table} from '../model/table';
import {TableDto} from '../model/tableDto';
import {TableLiteDto} from '../model/tableLiteDto';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorTableService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Ajouter un champ à une table
     * Cette requête permet d&#39;ajouter un champ à une table.
     * @param xDataStoreID X-DataStoreID
     * @param categoryField categoryField
     * @param fieldCode fieldCode
     * @param tableCode tableCode
     * @param type type
     * @param anonymizable anonymizable
     * @param autoIncrement autoIncrement
     * @param displayableUIPersonal displayableUIPersonal
     * @param labels labels
     * @param notNull notNull
     * @param pk pk
     * @param unique unique
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addFieldTableNameUsingPOST(xDataStoreID: string, categoryField: 'TECHNICAL' | 'EMAIL' | 'TEXT' | 'NUMBER' | 'DATE' | 'DATE_TIME' | 'TIME' | 'IATA_CITY' | 'IATA_AIRPORT' | 'IATA_COUNTRY' | 'CARRIER' | 'AFFILIATION' | 'LANG' | 'COUNTRY' | 'CIVILITY' | 'BOOLEAN' | 'PHONE' | 'MOBILE' | 'PRICE' | 'BOOKING_REFERENCE' | 'PRODUCT_TYPE', fieldCode: string, tableCode: string, type: 'String255' | 'String25' | 'String3' | 'String100' | 'String10' | 'String50' | 'TEXT' | 'Int' | 'BigInt' | 'Decimal_5_2' | 'Decimal_8_2' | 'Decimal_11_2' | 'Boolean' | 'DateTime' | 'Date' | 'Time' | 'UUID', anonymizable?: boolean, autoIncrement?: boolean, displayableUIPersonal?: boolean, labels?: any, notNull?: boolean, pk?: boolean, unique?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addFieldTableNameUsingPOST(xDataStoreID: string, categoryField: 'TECHNICAL' | 'EMAIL' | 'TEXT' | 'NUMBER' | 'DATE' | 'DATE_TIME' | 'TIME' | 'IATA_CITY' | 'IATA_AIRPORT' | 'IATA_COUNTRY' | 'CARRIER' | 'AFFILIATION' | 'LANG' | 'COUNTRY' | 'CIVILITY' | 'BOOLEAN' | 'PHONE' | 'MOBILE' | 'PRICE' | 'BOOKING_REFERENCE' | 'PRODUCT_TYPE', fieldCode: string, tableCode: string, type: 'String255' | 'String25' | 'String3' | 'String100' | 'String10' | 'String50' | 'TEXT' | 'Int' | 'BigInt' | 'Decimal_5_2' | 'Decimal_8_2' | 'Decimal_11_2' | 'Boolean' | 'DateTime' | 'Date' | 'Time' | 'UUID', anonymizable?: boolean, autoIncrement?: boolean, displayableUIPersonal?: boolean, labels?: any, notNull?: boolean, pk?: boolean, unique?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addFieldTableNameUsingPOST(xDataStoreID: string, categoryField: 'TECHNICAL' | 'EMAIL' | 'TEXT' | 'NUMBER' | 'DATE' | 'DATE_TIME' | 'TIME' | 'IATA_CITY' | 'IATA_AIRPORT' | 'IATA_COUNTRY' | 'CARRIER' | 'AFFILIATION' | 'LANG' | 'COUNTRY' | 'CIVILITY' | 'BOOLEAN' | 'PHONE' | 'MOBILE' | 'PRICE' | 'BOOKING_REFERENCE' | 'PRODUCT_TYPE', fieldCode: string, tableCode: string, type: 'String255' | 'String25' | 'String3' | 'String100' | 'String10' | 'String50' | 'TEXT' | 'Int' | 'BigInt' | 'Decimal_5_2' | 'Decimal_8_2' | 'Decimal_11_2' | 'Boolean' | 'DateTime' | 'Date' | 'Time' | 'UUID', anonymizable?: boolean, autoIncrement?: boolean, displayableUIPersonal?: boolean, labels?: any, notNull?: boolean, pk?: boolean, unique?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addFieldTableNameUsingPOST(xDataStoreID: string, categoryField: 'TECHNICAL' | 'EMAIL' | 'TEXT' | 'NUMBER' | 'DATE' | 'DATE_TIME' | 'TIME' | 'IATA_CITY' | 'IATA_AIRPORT' | 'IATA_COUNTRY' | 'CARRIER' | 'AFFILIATION' | 'LANG' | 'COUNTRY' | 'CIVILITY' | 'BOOLEAN' | 'PHONE' | 'MOBILE' | 'PRICE' | 'BOOKING_REFERENCE' | 'PRODUCT_TYPE', fieldCode: string, tableCode: string, type: 'String255' | 'String25' | 'String3' | 'String100' | 'String10' | 'String50' | 'TEXT' | 'Int' | 'BigInt' | 'Decimal_5_2' | 'Decimal_8_2' | 'Decimal_11_2' | 'Boolean' | 'DateTime' | 'Date' | 'Time' | 'UUID', anonymizable?: boolean, autoIncrement?: boolean, displayableUIPersonal?: boolean, labels?: any, notNull?: boolean, pk?: boolean, unique?: boolean, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling addFieldTableNameUsingPOST.');
        }

        if (categoryField === null || categoryField === undefined) {
            throw new Error('Required parameter categoryField was null or undefined when calling addFieldTableNameUsingPOST.');
        }

        if (fieldCode === null || fieldCode === undefined) {
            throw new Error('Required parameter fieldCode was null or undefined when calling addFieldTableNameUsingPOST.');
        }

        if (tableCode === null || tableCode === undefined) {
            throw new Error('Required parameter tableCode was null or undefined when calling addFieldTableNameUsingPOST.');
        }

        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling addFieldTableNameUsingPOST.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (anonymizable !== undefined && anonymizable !== null) {
            queryParameters = queryParameters.set('anonymizable', <any> anonymizable);
        }
        if (autoIncrement !== undefined && autoIncrement !== null) {
            queryParameters = queryParameters.set('autoIncrement', <any> autoIncrement);
        }
        if (categoryField !== undefined && categoryField !== null) {
            queryParameters = queryParameters.set('categoryField', <any> categoryField);
        }
        if (displayableUIPersonal !== undefined && displayableUIPersonal !== null) {
            queryParameters = queryParameters.set('displayableUIPersonal', <any> displayableUIPersonal);
        }
        if (notNull !== undefined && notNull !== null) {
            queryParameters = queryParameters.set('notNull', <any> notNull);
        }
        if (pk !== undefined && pk !== null) {
            queryParameters = queryParameters.set('pk', <any> pk);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any> type);
        }
        if (unique !== undefined && unique !== null) {
            queryParameters = queryParameters.set('unique', <any> unique);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/tables/${encodeURIComponent(String(tableCode))}/fields/${encodeURIComponent(String(fieldCode))}`,
            labels,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Créer une nouvelle table (dto)
     * Cette requête permet de créer une nouvelle table et la renvoyer. (code 201)&lt;br&gt;Si la table a un identifiant, une erreur est renvoyée. (code 400)&lt;br&gt;Noter que cette requête renvoie une table en dto.
     * @param xDataStoreID X-DataStoreID
     * @param tableDto tableDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTableUsingPOST1(xDataStoreID: string, tableDto: TableDto, observe?: 'body', reportProgress?: boolean): Observable<TableDto>;
    public createTableUsingPOST1(xDataStoreID: string, tableDto: TableDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TableDto>>;
    public createTableUsingPOST1(xDataStoreID: string, tableDto: TableDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TableDto>>;
    public createTableUsingPOST1(xDataStoreID: string, tableDto: TableDto, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTableUsingPOST1.');
        }

        if (tableDto === null || tableDto === undefined) {
            throw new Error('Required parameter tableDto was null or undefined when calling createTableUsingPOST1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TableDto>(`${this.basePath}/api/table`,
            tableDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Créer une nouvelle table
     * Cette requête permet de créer une nouvelle table et la renvoyer. (code 201)&lt;br&gt;Si la table a un identifiant, une erreur est renvoyée. (code 400)&lt;br&gt;Noter que cette requête renvoie une table et pas un dto.
     * @param xDataStoreID X-DataStoreID
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTableUsingPOST2(xDataStoreID: string, table: Table, observe?: 'body', reportProgress?: boolean): Observable<Table>;
    public createTableUsingPOST2(xDataStoreID: string, table: Table, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Table>>;
    public createTableUsingPOST2(xDataStoreID: string, table: Table, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Table>>;
    public createTableUsingPOST2(xDataStoreID: string, table: Table, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTableUsingPOST2.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling createTableUsingPOST2.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Table>(`${this.basePath}/api/tables`,
            table,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir les champs d&#39;une table
     * Cette requête permet d&#39;obtenir tous les champs d&#39;une table.
     * @param xDataStoreID X-DataStoreID
     * @param tableName tableName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllFieldForTableNameUsingGET1(xDataStoreID: string, tableName: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FieldTable>>;
    public getAllFieldForTableNameUsingGET1(xDataStoreID: string, tableName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FieldTable>>>;
    public getAllFieldForTableNameUsingGET1(xDataStoreID: string, tableName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FieldTable>>>;
    public getAllFieldForTableNameUsingGET1(xDataStoreID: string, tableName: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllFieldForTableNameUsingGET1.');
        }

        if (tableName === null || tableName === undefined) {
            throw new Error('Required parameter tableName was null or undefined when calling getAllFieldForTableNameUsingGET1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<FieldTable>>(`${this.basePath}/api/tables/${encodeURIComponent(String(tableName))}/fields`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister une table par son nom
     * Cette requête permet de chercher une table par son nom et de traduire ses champs. (code 200)Les valeur que \&quot;X_LANG\&quot; peut prendre sont : EN, FR, IT, DE, NL, ES;
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param name name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTableUsingGET(xDataStoreID: string, name: string, observe?: 'body', reportProgress?: boolean): Observable<Table>;
    public getTableUsingGET(xDataStoreID: string, name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Table>>;
    public getTableUsingGET(xDataStoreID: string, name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Table>>;
    public getTableUsingGET(xDataStoreID: string, name: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTableUsingGET.');
        }

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling getTableUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Table>(`${this.basePath}/api/tables/${encodeURIComponent(String(name))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister les tables par leurs noms
     * Cette requête permet de lister les tables par leurs noms. (code 200)Les valeur que \&quot;X_LANG\&quot; peut prendre sont : EN, FR, IT, DE, NL, ES;
     * @param xDataStoreID X-DataStoreID
     * @param name name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTablesUsingGET(xDataStoreID: string, name?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<Table>>;
    public getTablesUsingGET(xDataStoreID: string, name?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Table>>>;
    public getTablesUsingGET(xDataStoreID: string, name?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Table>>>;
    public getTablesUsingGET(xDataStoreID: string, name?: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTablesUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name) {
            name.forEach((element) => {
                queryParameters = queryParameters.append('name', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Table>>(`${this.basePath}/api/tables/list`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Synchroniser les tables
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public syncAllTablesUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<TableLiteDto>>;
    public syncAllTablesUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TableLiteDto>>>;
    public syncAllTablesUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TableLiteDto>>>;
    public syncAllTablesUsingGET(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TableLiteDto>>(`${this.basePath}/api/tables/sync`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un label d&#39;une table donnée
     * Cette requête permet de modifier un label existant d&#39;une table donnée.
     * @param xDataStoreID X-DataStoreID
     * @param fieldCode fieldCode
     * @param newLabels newLabels
     * @param tableName tableName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFieldLabelUsingPUT1(xDataStoreID: string, fieldCode: string, newLabels: any, tableName: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateFieldLabelUsingPUT1(xDataStoreID: string, fieldCode: string, newLabels: any, tableName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateFieldLabelUsingPUT1(xDataStoreID: string, fieldCode: string, newLabels: any, tableName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateFieldLabelUsingPUT1(xDataStoreID: string, fieldCode: string, newLabels: any, tableName: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateFieldLabelUsingPUT1.');
        }

        if (fieldCode === null || fieldCode === undefined) {
            throw new Error('Required parameter fieldCode was null or undefined when calling updateFieldLabelUsingPUT1.');
        }

        if (newLabels === null || newLabels === undefined) {
            throw new Error('Required parameter newLabels was null or undefined when calling updateFieldLabelUsingPUT1.');
        }

        if (tableName === null || tableName === undefined) {
            throw new Error('Required parameter tableName was null or undefined when calling updateFieldLabelUsingPUT1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/tables/${encodeURIComponent(String(tableName))}/fields/${encodeURIComponent(String(fieldCode))}/label`,
            newLabels,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier la description d&#39;une table
     * Cette requête permet de modifier une description d&#39;une table.
     * @param xDataStoreID X-DataStoreID
     * @param description description
     * @param tableName tableName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTableDescriptionUsingPUT1(xDataStoreID: string, description: string, tableName: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateTableDescriptionUsingPUT1(xDataStoreID: string, description: string, tableName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateTableDescriptionUsingPUT1(xDataStoreID: string, description: string, tableName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateTableDescriptionUsingPUT1(xDataStoreID: string, description: string, tableName: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTableDescriptionUsingPUT1.');
        }

        if (description === null || description === undefined) {
            throw new Error('Required parameter description was null or undefined when calling updateTableDescriptionUsingPUT1.');
        }

        if (tableName === null || tableName === undefined) {
            throw new Error('Required parameter tableName was null or undefined when calling updateTableDescriptionUsingPUT1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/tables/${encodeURIComponent(String(tableName))}/description`,
            description,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un label d&#39;une table
     * Cette requête permet de modifier un champ d&#39;une table, suivant la langue passée en paramètre.&lt;br/&gt;Elle prend en paramètre l&#39;identifiant de la table, le nom du champ et la traduction du champ en autres langues.Les valeur que ces derniers peut prendre sont : EN, FR, IT, DE, NL, ES;
     * @param xDataStoreID X-DataStoreID
     * @param newLabels newLabels
     * @param tableName tableName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTableLabelUsingPUT1(xDataStoreID: string, newLabels: any, tableName: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateTableLabelUsingPUT1(xDataStoreID: string, newLabels: any, tableName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateTableLabelUsingPUT1(xDataStoreID: string, newLabels: any, tableName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateTableLabelUsingPUT1(xDataStoreID: string, newLabels: any, tableName: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTableLabelUsingPUT1.');
        }

        if (newLabels === null || newLabels === undefined) {
            throw new Error('Required parameter newLabels was null or undefined when calling updateTableLabelUsingPUT1.');
        }

        if (tableName === null || tableName === undefined) {
            throw new Error('Required parameter tableName was null or undefined when calling updateTableLabelUsingPUT1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/tables/${encodeURIComponent(String(tableName))}/label`,
            newLabels,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
